<template>
  <div id="links">
    <h1 class="title text-uppercase font-weight-bold">
      Relação Lojistas por Link
    </h1>
    <hr class="linha-amarela" />
    <div v-if="this.links.length > 1" class="limit-table">
      <table class="table">
        <thead class="letter-orange">
          <tr>
            <th>Link</th>
            <th>Nº Lojistas Cadastrados</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="link in links" :key="link.id">
            <td v-if="link.link !== null">
              <a class="btn btn-primary w-100" :href="link.link">
                {{ link.shorten_link }}
              </a>
            </td>
            <td v-else>Sem Link</td>
            <td class="align-middle" v-if="link.quantidade_lojistas > 0">
              Já foram cadastrados {{ link.quantidade_lojistas }} lojista(s)
              neste link!
            </td>
            <td class="align-middle" v-else>Sem lojistas</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-else class="text-white">
      <center style="background: red">
        <i class="fas fa-times"></i> Nenhum lojista cadastrado!
      </center>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import makeToast from '../../mixins/makeToast';
import SelectDates from '../../components/Menu/SelectDates.vue';

export default {
  name: 'links',
  mixins: [makeToast],
  components: {
    SelectDates,
  },
  data() {
    return {
      links: [],
    };
  },
  computed: {
    ...mapState(['token', 'dadosUsuario']),
    ...mapGetters('partner', ['setPartners']),
  },
  created() {
    this.getShopkeepersPerLink()
      .then((response) => {
        this.links = response.data;
      })
      .catch((error) => {
        console.log(error);
        this.makeToast(
          'Oopss!',
          'Não foi possivel carregar a lista!',
          'danger'
        );
      });
  },
  methods: {
    ...mapActions('partner', ['getShopkeepersPerLink']),
    aviso(texto, tipo) {
      this.$bvToast.toast(texto, {
        title: 'Aviso',
        variant: tipo,
        autoHideDelay: 5000,
        appendToast: true,
      });
    },
  },
};
</script>
